import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, defer, from, shareReplay } from 'rxjs';
import { KbSection, AiSearchResponse } from './knowledge-base.models';
import { environment } from '@myenv/environment';

@Injectable({ providedIn: 'root' })
export class KnowledgeBaseService {
  private readonly http = inject(HttpClient);

  /** Uses fetch so local assets are not altered by global HttpClient interceptors. */
  private readonly sections$ = defer(() =>
    from(
      fetch('assets/knowledge-base/sections.json').then(async (res) => {
        if (!res.ok) {
          throw new Error('Failed to load knowledge base sections');
        }
        return (await res.json()) as KbSection[];
      })
    )
  ).pipe(shareReplay({ bufferSize: 1, refCount: true }));

  getSections(): Observable<KbSection[]> {
    return this.sections$;
  }

  /** POST `{apiUrl}/knowledge/search` (same base as other API calls). */
  aiSearch(query: string): Observable<AiSearchResponse> {
    const base = String(environment.apiUrl ?? '').trim().replace(/\/$/, '');
    if (!base) {
      throw new Error('AI search requires environment.apiUrl.');
    }
    const url = `${base}/knowledge/search`;
    return this.http.post<AiSearchResponse>(url, { query });
  }
}